import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { ADAPTIVE } from '@yme/tokens/screen';
import { LOGO_SIZE_VALUES_FOOTER, LOGO_SIZE_VALUES_HEADER } from './constants';
export const DefaultLogoStyled = styled.span `
  display: inline-block;
`;
export const LogoLinkHeaderStyled = styled(Link) `
  display: flex;
  align-items: center;

  max-width: ${LOGO_SIZE_VALUES_HEADER.s.width}px;
`;
export const LogoHeaderStyled = styled(DefaultLogoStyled) `
  &,
  & > svg {
    height: ${LOGO_SIZE_VALUES_HEADER.s.height}px;
    width: ${LOGO_SIZE_VALUES_HEADER.s.width}px;
  }
`;
export const LogoFooterStyled = styled(DefaultLogoStyled) `
  &,
  & > svg {
    height: ${LOGO_SIZE_VALUES_FOOTER.s.height}px;
    width: ${LOGO_SIZE_VALUES_FOOTER.s.width}px;

    ${ADAPTIVE.minWidth.tablet} {
      height: ${LOGO_SIZE_VALUES_FOOTER.m.height}px;
      width: ${LOGO_SIZE_VALUES_FOOTER.m.width}px;
    }

    ${ADAPTIVE.minWidth.desktop} {
      height: ${LOGO_SIZE_VALUES_FOOTER.l.height}px;
      width: ${LOGO_SIZE_VALUES_FOOTER.l.width}px;
    }
  }
`;
